import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, Paragraph } from '@fs/zion-ui'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../hooks/useNotifications'
import { updateGroupProperties } from '../../services/groupsService'
import { GroupContext } from '../group/GroupContextProvider'

export default function RestoreTombstonedGroupDialogOverlay({ ...overlay }) {
  const { t } = useTranslation()
  const { currentGroupData, fetchCurrentGroupData } = useContext(GroupContext)
  const { error, ok } = useNotifications()

  const confirmBtnOnClick = async () => {
    try {
      const groupUpdateProperties = {
        name: currentGroupData.name,
        description: currentGroupData.description,
        tombstoned: false,
        joinPolicy: currentGroupData.joinPolicy,
        sizeLimit: currentGroupData.sizeLimit.toString(),
        codeOfConduct: currentGroupData.codeOfConduct,
        treeInitialized: currentGroupData.treeInitialized,
        types: currentGroupData.types,
        organizationId: currentGroupData.organizationId,
        private: currentGroupData.private,
      }
      overlay.close()
      await updateGroupProperties(currentGroupData.id, groupUpdateProperties)
      fetchCurrentGroupData()
      ok(t('success', 'Success'))
    } catch (err) {
      error(
        t('metadata.errors.restoringGroup', {
          defaultValue: `Error restoring group: ${err.message || ''}`,
          message: err.message || '',
        }),
        err
      )
    }
  }

  return (
    <DialogOverlay
      {...overlay}
      title={t('group.summary.dialogOverlay.restore.heading', 'Restore Tombstoned Group')}
      subtitle={currentGroupData.id}
    >
      <Paragraph size="sm">
        {t('group.summary.dialogOverlay.restore.body', 'Are you sure you want to restore this tombstoned group?')}
      </Paragraph>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button emphasis="high" onClick={confirmBtnOnClick}>
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button emphasis="medium" onClick={overlay.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
